/* ──────────────────────────────────────────────────────────────────────────
 * Analytics environment gating.
 *
 * Local development typically uses the same NEXT_PUBLIC_POSTHOG_KEY as
 * production, so without a gate every `npm run dev` session pollutes the
 * production PostHog project with the founder's own traffic.
 *
 * This helper is the single source of truth for "should client analytics run
 * on this host?" — consumed by instrumentation-client.ts (to skip init) and
 * by /internal (to show the right state). Keep both in sync via this function.
 *
 * It's a hostname check, not a NODE_ENV check, so it also suppresses analytics
 * when running a production build locally (`npm run build && npm start`).
 * ────────────────────────────────────────────────────────────────────────── */

/** Hostnames where client analytics (PostHog) must not run. */
export function isAnalyticsDisabledHost(hostname: string): boolean {
  return hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1";
}
